<template>
  <section class="Details w-full flex flex-col">
    <AppAccordion v-model="expanded" name="description" class="border-b border-deals-45">
      <template #summary>
        <h3 class="text-primary-1-100 text-lg-1 flex items-center">
          <svg-icon-description class="mr-4 w-6 h-6" />
          <span>{{ $t('productDescription') }}</span>
        </h3>
      </template>
      <div v-purify="features" class="text-primary-1-60 text-base mb-5"></div>
    </AppAccordion>

    <AppAccordion v-model="expanded" name="returns">
      <template #summary>
        <h3 class="text-primary-1-100 text-lg-1 flex items-center">
          <svg-icon-return class="mr-4 w-6 h-6" />
          <span>{{ $t('returnPolicy') }}</span>
        </h3>
      </template>
      <div class="text-primary-1-100">
        <AppLink
          to="/faqs"
          class="flex items-center [ uppercase text-sm ] mb-5 underline"
          :aria-label="$t('deliveryContent')"
        >
          {{ $t('returnsRefundsPolicy') }}
        </AppLink>
      </div>
    </AppAccordion>
  </section>
</template>

<script setup lang="ts">
defineComponent({
  name: 'ProductPageDetails',
});
const { t: $t } = useI18n({ useScope: 'local' });

const { product } = useProductContext();
const expanded = ref<'description' | 'returns' | null>('description');
const features = computed(() => product?.value?.description?.html);
</script>

<style lang="postcss" scoped>
.Details {
  @apply mx-auto;

  :deep(.AppAccordion) {
    .Summary {
      padding: 24px 0;
    }
  }
}

.Specs {
  li {
    @apply py-4;
    padding: 16px 0;
  }
}

.product-details-grid {
  @apply flex flex-col-reverse gap-y-16 px-5 md:px-0;

  @screen md {
    display: grid;
    grid-template-columns: 472px 1fr;
    column-gap: 64px;
  }
}
</style>
<i18n>
{
  "en": {
    "productDescription": "Description",
    "confectionAndTransparency": "Confection & Transparency",
    "returnsRefundsPolicy": "returns and refund policy",
    "returnPolicy": "Shipping, Exchange & Returns",
    "deliveryDetails": "Delivery Details",
    "deliveryContent": "Delivery Content",
    "storeAvailability": "Store Availability",
    "securePayments":"Secure Payments",
    "securePaymentsContent":"Secure Payments",
    "securePayment": "Secure payment"
  },
  "ar": {
    "productDescription": "وصف المنتج",
    "confectionTransparency": "الحلويات والشفافية",
    "returnsRefundsPolicy": "سياسة الاسترجاع و الاسترداد",
    "returnPolicy": "الشحن والاستبدال والإرجاع",
    "deliveryDetails": "تفاصيل التسليم",
    "deliveryContent": "المحتوى",
    "storeAvailability": "التوفر في المتجر",
    "securePayments":"مدفوعات آمنة",
    "securePaymentsContent":"Secure Payments",
    "securePayment": "الدفع الآمن"
  }
}
</i18n>
